import React from "react"
import ClueSystem from "./ClueSystem"
import Audio from "./Audio"

function Footer(props) {        
    const cluepad = props.clueSystem ? <ClueSystem pageId={props.currentPage} memoryGame={props.memoryGame} callBackTimer={props.callBackTimer} updateClues={props.updateClues} callBackCluesUpdated={props.callBackCluesUpdated} addClueOption={props.addClueOption} removeClueOption={props.removeClueOption}/> : ""
       
    return (
        <footer className="phaseFooter">
            {cluepad}
            <Audio pageId={props.currentPage} gameEndId={props.gameEndId} />
        </footer>
    )
}

export default Footer